module.exports = __webpack_public_path__ + "img/liu.2334cd48.png";